import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { MobileNav } from '../components/MobileNav';
export function DecodeEntry() {
  return <>
      <Helmet data-id="element-923">
        <title data-id="element-924">Start a Decode | Lazy Monk Labs</title>
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-925">
        <MobileNav data-id="element-926" />

        <main className="pt-20 sm:pt-24 pb-16 sm:pb-20" data-id="element-927">
          <div className="max-w-2xl mx-auto px-6 sm:px-8" data-id="element-928">
            {/* Headline — Authority, not suggestion */}
            <section className="py-12 sm:py-16" data-id="element-929">
              <h1 className="text-2xl sm:text-3xl md:text-4xl leading-tight text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-930">
                Choose your entry point.
              </h1>
            </section>

            {/* Two Options — Personal primary, Situation secondary */}
            <section className="space-y-4 sm:space-y-6" data-id="element-931">
              {/* PRIMARY — Your Blueprint */}
              <Link to="/decode/details" className="block border border-[#2B2B2B] bg-[#111214] p-7 sm:p-9 hover:border-gray-500 transition-colors group" data-id="element-932">
                <h2 className="text-xl sm:text-2xl text-[#F5F5F5] mb-3 group-hover:text-white transition-colors" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-933">
                  Your core patterns
                </h2>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed mb-4" data-id="element-934">
                  Enter your birth details. Receive a structural read of your
                  core pattern.
                </p>
                <div className="flex items-center justify-between" data-id="element-935">
                  <span className="text-xs text-gray-600" data-id="element-936">
                    Deeper. Identity-level.
                  </span>
                  <span className="text-sm text-[#F5F5F5] uppercase tracking-widest font-medium group-hover:text-gray-200 transition-colors" data-id="element-937">
                    Start Personal Decode
                  </span>
                </div>
              </Link>

              {/* SECONDARY — Your Current Moment */}
              <Link to="/decode/input" className="block border border-[#2B2B2B] p-6 sm:p-8 hover:border-gray-500 transition-colors group" data-id="element-938">
                <div className="flex items-start justify-between mb-3" data-id="element-939">
                  <h2 className="text-lg sm:text-xl text-gray-300 group-hover:text-white transition-colors" data-id="element-940">
                    Your current moment
                  </h2>
                  <span className="text-[10px] font-mono text-gray-600 uppercase tracking-widest border border-[#2B2B2B] px-2 py-0.5 rounded-sm flex-shrink-0 ml-4" data-id="element-941">
                    Beta
                  </span>
                </div>
                <p className="text-sm text-gray-500 leading-relaxed mb-3" data-id="element-942">
                  Describe what's happening. See how the pattern is expressing
                  right now.
                </p>
                <span className="text-xs text-gray-600" data-id="element-943">
                  Moment-level structural read.
                </span>
              </Link>
            </section>

            {/* Privacy reassurance */}
            <section className="pt-12 sm:pt-16" data-id="element-944">
              <p className="text-xs text-gray-600" data-id="element-945">
                Nothing is stored unless you choose to save it.
              </p>
            </section>
          </div>
        </main>
      </div>
    </>;
}